// src/components/PdfPreview.jsx
import React, { useMemo, useRef, useState, useEffect } from 'react';

// prosty heurystyczny check dla iOS Safari (iframe z PDF bywa kapryśny)
function isIosSafari(){
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || navigator.vendor || '';
    const iOS = /iPad|iPhone|iPod/.test(ua);
    const webkit = /WebKit/.test(ua);
    const isCriOS = /CriOS/.test(ua);
    const isFxiOS = /FxiOS/.test(ua);
    return iOS && webkit && !isCriOS && !isFxiOS;
}

export default function PdfPreview({ url, name = 'Załącznik PDF', maxHeight = 620 }) {
    const [open, setOpen] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [failed, setFailed] = useState(false);
    const frameRef = useRef(null);

    const iosSafari = useMemo(() => isIosSafari(), []);

    useEffect(() => {
        if (!open) { setLoaded(false); setFailed(false); }
    }, [open]);

    return (
        <div style={{ border:'1px solid #eee', borderRadius:10, overflow:'hidden', background:'#fafafa' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 12px' }}>
                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span role="img" aria-label="PDF">📄</span>
                    <strong style={{ fontWeight:600 }}>{name}</strong>
                </div>
                <div style={{ display:'flex', gap:8 }}>
                    <button  className={'but-smal'} onClick={() => setOpen(v => !v)}>
                        {open ? 'Ukryj podgląd' : 'Pokaż podgląd'}
                    </button>
                    {/* awaryjna opcja – tylko jeśli iframe nie działa */}
                    {open && (iosSafari || failed) && (
                        <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration:'none' }}>
                            <button  className={'but-smal'}>Otwórz w nowej karcie</button>
                        </a>
                    )}
                </div>
            </div>

            {open && (
                <div style={{ borderTop:'1px solid #eee', background:'#fff' }}>
                    {!iosSafari && !failed ? (
                        <div style={{ position:'relative', height: maxHeight, background:'#000' }}>
                            {!loaded && (
                                <div style={{
                                    position:'absolute', inset:0, display:'grid', placeItems:'center',
                                    color:'#444', background:'#fff'
                                }}>
                                    Wczytywanie PDF…
                                </div>
                            )}
                            <iframe
                                ref={frameRef}
                                title={name}
                                src={url}
                                style={{ width:'100%', height:'100%', border:'0', display: loaded ? 'block' : 'none' }}

                                // uwaga: nie nadpisujemy clipboardu/drukowania w natywnym viewerze
                                onLoad={() => setLoaded(true)}
                                onError={() => setFailed(true)}
                            />
                        </div>
                    ) : (
                        <div style={{ padding:12 }}>
                            <div style={{ marginBottom:8 }}>
                                Twoja przeglądarka może nie obsługiwać wbudowanego podglądu PDF. Użyj linku poniżej.
                            </div>
                            <a href={url} target="_blank" rel="noopener noreferrer">{name}</a>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
